import { DateUtils } from "@utils/dayUtill";
import type { NurseResponse } from "@vTypes/nurse-type";

interface NurseBasicInfoProps {
  nurseData?: NurseResponse;
}

export default function NurseBasicInfo({ nurseData }: NurseBasicInfoProps) {
  return (
    <div className="px-6 py-4 border-b-4 border-[#F0F0F2]">
      <div className="grid grid-cols-2 text-[15px] gap-y-[14px] gap-x-2 font-pretendard">
        <InfoItem label="아이디" value={nurseData?.account_id || "-"} />

        <InfoItem
          label="재직기간"
          value={
            !nurseData?.joining_date
              ? "-"
              : DateUtils.getTenureString(
                  nurseData?.joining_date,
                  nurseData?.resignation_date
                )
          }
        />
        <InfoItem
          label="연락처"
          value={nurseData?.phone_number || "-"}
          className="col-span-2"
        />
      </div>
    </div>
  );
}

export function InfoItem({
  label,
  value,
  className = "",
}: {
  label: string;
  value: string;
  className?: string;
}) {
  return (
    <div className={`flex items-center ${className}`}>
      <span className="text-[#939393] text-[15px] font-medium font-pretendard">
        {label}
      </span>
      <span className="ml-1.5 text-sm text-[#333333] font-pretendard">
        {value}
      </span>
    </div>
  );
}
